module.exports = __webpack_public_path__ + "b441cd62d90647445bdffd1e5e51f460.jpg";